<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
        <li class="breadcrumb-item">
            <router-link to="/Sale/orders">{{ $t('sale_order') }}</router-link>
        </li>
        <li class="breadcrumb-item">
            <router-link to="/Sale/invoices">{{ $t('sale_invoice') }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">[{{invoice.DocSourceNo}}]</li>
    </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="save">
            <i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="label-control blue">{{ $t('customer') }}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" readonly v-model="invoice.CustomerName" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="label-control blue">{{ $t('date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="invoice.Date" @change="onDateChange"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="label-control blue">{{ $t('due_date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="invoice.DueDate"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-sm table-bordered table-striped no-bor">
                            <thead>
                                <tr>
                                    <th style="width: 30px;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('cost')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('price_sale')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center" style="width: 30px;">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$money(ret.Cost)}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('total')}}</th>
                                    <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="label-control blue">{{ $t('remark') }}</label>
                            <textarea class="form-control form-control-sm" v-model="invoice.Description"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import moment from 'moment';
    export default {
        data: function(){
            return {
                invoice: {
                    Date: this.$now().format('YYYY-MM-DD'),
                    DueDate: this.$now().format('YYYY-MM-DD'),
                    CustomerId: '',
                    CustomerName: '',
                    CustomerTypeId: '',
                    GrandTotal: 0,
                    UntaxAmount: 0,
                    TaxVat: 0,
                    TotalAmount: 0,
                    Status: 'Draft',
                    DocSource: 'Order',
                    DocSourceNo: ''
                },
                lines: [],
                types: [],
                actionLink: 'sale/invoice/save',
            }
        },
        async created(){
            let id = this.$route.params.id;
            await this.typeList();
            this.findById(id);
        },
        methods: {
            async typeList(){
                var res = await this.$api().post('customer/types');
                if(this.$isValid(res)){
                    this.types = res.data.Json.Types;
                }
            },
            save(){
                var req = {
                    Header: this.invoice,
                    Lines: this.lines
                };
                let loading = this.$loading.show();
                this.$api().post(this.actionLink, req).then(res => {
                    if(this.$isValid(res)){this.$router.push('/sale/invoices');}
                }).finally(function(){ loading.hide(); });
            },
            customerSelected(item){
                this.invoice.CustomerId = item.Id;
            },
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('sale/order/invoice', { Id: id}).then(res => {
                    var data = res.data.Json;
                    this.invoice = data.Header;
                    this.invoice.Date = this.$format(this.invoice.Date, 'YYYY-MM-DD');
                    this.lines = data.Lines;
                    this.updateDueDate();
                }).finally(function(){ loading.hide(); });
            },
            onDateChange(){
                this.updateDueDate();
            },
            updateDueDate(){
                var ctype = this.types.find(el => el.Id == this.invoice.CustomerTypeId);
                if(ctype != undefined){
                    this.invoice.DueDate = moment(this.invoice.Date).add(ctype.DueDay, 'days').format('YYYY-MM-DD');
                }else{
                    if(moment(this.invoice.Date).diff(this.invoice.DueDate, 'days') > 0) this.invoice.DueDate = this.invoice.Date;
                }
            }
        }
    }
</script>
<style scoped>x
    label{
        margin-bottom: 0;
    }
</style>
